import {
  collection,
  FirestoreDataConverter,
  Timestamp,
} from "firebase/firestore";
import { db } from "integrations/firebase/firestore";
import {
  GenerationMetadataEvent,
  OnixImportMetadataEvent,
} from "reedy-data/models";

export type FirestoreMetadataEvent =
  | OnixImportMetadataEvent
  | GenerationMetadataEvent;

type FirestoreMetadataEventFromFirebase =
  | (Omit<OnixImportMetadataEvent, "occurredAt"> & { occurredAt: Timestamp })
  | (Omit<GenerationMetadataEvent, "occurredAt"> & { occurredAt: Timestamp });

const metadataEventConverter: FirestoreDataConverter<FirestoreMetadataEvent> = {
  toFirestore(event) {
    return event;
  },
  fromFirestore(snapshot) {
    const data = snapshot.data() as FirestoreMetadataEventFromFirebase;
    return {
      ...data,
      occurredAt: data.occurredAt.toDate(),
      id: data.id || snapshot.id,
    };
  },
};

export const getMetadataEventsCollection = () =>
  collection(db, "metadataEvents").withConverter(metadataEventConverter);
